(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["sabrina-gallery"] && !Shopify.designMode) return;
  try {
    function setupSabrinaGalleries(root = document) {
 root.querySelectorAll('[data-sf-gallery]').forEach(gallery => {
  if (gallery.dataset.ready) return;
  gallery.dataset.ready = 'true';
  const track = gallery.querySelector('.sf-gallery-track');
  const next = gallery.querySelector('[data-gallery-next]');
  const prev = gallery.querySelector('[data-gallery-prev]');
  const update = () => { prev.disabled = track.scrollLeft < 2; next.disabled = track.scrollLeft + track.clientWidth >= track.scrollWidth - 3; };
  next.addEventListener('click', () => track.scrollBy({left:track.clientWidth*.75, behavior:matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth'}));
  prev.addEventListener('click', () => track.scrollBy({left:-track.clientWidth*.75, behavior:matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth'}));
  track.addEventListener('scroll', update, {passive:true});
  new ResizeObserver(update).observe(track); update();
 });
}
setupSabrinaGalleries();
document.addEventListener('shopify:section:load', event => setupSabrinaGalleries(event.target));
  } catch(e) { console.error(e); }
})();

})();
